import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import { Row, Col, CampoEstatico, TipoCampoEstatico, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { HomeCard } from "./../HomeCard";
import { HomeContext } from "../../../contexts";
import { PlanoVinculadoEntidade } from "../../../entidades";
import { LoadingComponent } from "../../../components";
import { PlanoService } from "./../../../services";

export const AtivoSaldado: React.FC = () => {
  const context = useContext(HomeContext);

  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>(new PlanoVinculadoEntidade());

  const [Loading, setLoading] = useState<boolean>(false);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const Plano = await PlanoService.BuscarSaldado();

        setPlano(Plano);
      }
      catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [context]);

  return (
    <div>
      {Loading && <LoadingComponent />}

      {!Loading && Erro !== "" && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

      {!Loading && Erro === "" && Plano &&
        <div>
          <Row>
            <Col>
              <HomeCard titulo={"PLANO BD SALDADO"}>
                {Plano.DS_SIT_PLANO}
              </HomeCard>
            </Col>
            <Col>
              <HomeCard titulo={"Data Saldamento"}>
                {Plano.DT_INSC_PLANO}
              </HomeCard>
            </Col>
          </Row>
          <Row>
            <Col>
              <HomeCard titulo={"Valor Inicial do Saldamento"}>
                <CampoEstatico valor={Plano.VL_BENEF_SALDADO_INICIAL} tipo={TipoCampoEstatico.dinheiro} />
              </HomeCard>
            </Col>
            <Col>
              <HomeCard titulo={"Valor Atualizado"} label={`em ${moment(Plano.DT_INIC_VALIDADE, "DD/MM/YYYY").format("DD/MM/YYYY")}`}>
                <CampoEstatico valor={Plano.VL_BENEF_SALDADO_ATUAL} tipo={TipoCampoEstatico.dinheiro} />
              </HomeCard>
            </Col>
          </Row>
        </div>
      }
    </div>
  );
}